import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Container = styled.div<{ theme: Theme }>`
  display: grid;
  grid-auto-rows: 1px;
  column-gap: 40px;

  @media (${breakpoint.mmMin}) {
    &:not(.no-results) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (${breakpoint.hybridMin}) {
    &:not(.no-results) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  &.cards-container {
    padding: 20px;
    background: ${getColor('surfaceSecondary')};
    min-height: 500px;

    @media (${breakpoint.smMin}) {
      width: 100%;
    }
    @media (${breakpoint.mdMin}) {
      padding: 40px;
    }
  }
`;

export const Column = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: column;

  @media (${breakpoint.mdMin}) {
    width: calc(50% - 20px);
  }

  @media (${breakpoint.hybridMin}) {
    width: calc(33.33% - 27px);
  }
`;

export const NoResults = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'regular')};
  width: 100%;
  strong {
    font-weight: 600;
    line-height: 77px;
  }
`;
